/**
 * Sticky header cell for one resource. Subscribes to the interaction store
 * for its own "focused column" flag only — arrow keys re-render at most two
 * header cells, never the grid.
 */
import React from "react";
import { MCInteractionState, MCResource } from "./model/types";
import { MiniStore, useMiniSelector } from "./model/miniStore";

interface HeaderCellProps {
  resource: MCResource;
  store: MiniStore<MCInteractionState>;
}

const initialsOf = (title: string): string => {
  const parts = title
    .replace(/[()]/g, " ")
    .split(/[\s,.]+/)
    .filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const HeaderCell: React.FC<HeaderCellProps> = ({ resource, store }) => {
  const isFocused = useMiniSelector(
    store,
    (s) => s.focus?.resourceIndex === resource.index,
  );

  return (
    <div
      className={["mc-header-cell", isFocused ? "is-focused" : ""].filter(Boolean).join(" ")}
      data-resource-id={resource.id}
      title={resource.title}
    >
      <span className="mc-avatar" aria-hidden>
        {initialsOf(resource.title)}
      </span>
      <span className="mc-header-title">{resource.title}</span>
      {Boolean(resource.warningCount) && (
        <span className="mc-header-warning" title="Termine außerhalb der Arbeitszeit">
          ⚠ {resource.warningCount}
        </span>
      )}
    </div>
  );
};

export default React.memo(HeaderCell);
